import Model, {
  attr,
  belongsTo,
  hasMany,
  type AsyncBelongsTo,
  type AsyncHasMany,
} from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';
import type DeliverableModel from './deliverable';
import type ObservationModel from './observation';
import type RecommendationModel from './recommendation';
import type ScanModel from './scan';

export default class SectionModel extends Model {
  declare [Type]: 'section';
  @attr('string') declare name: string;
  @attr declare description: string;
  @attr declare created_at: string;
  @attr declare updated_at: string;

  @belongsTo('scan', {
    async: true,
    inverse: 'sections',
  })
  declare scan: AsyncBelongsTo<ScanModel>;

  @hasMany('observation', {
    async: true,
    inverse: 'section',
  })
  declare observations: AsyncHasMany<ObservationModel>;

  @hasMany('recommendation', {
    async: true,
    inverse: 'section',
  })
  declare recommendations: AsyncHasMany<RecommendationModel>;

  @hasMany('deliverable', {
    async: true,
    inverse: 'section',
  })
  declare deliverables: AsyncHasMany<DeliverableModel>;

  get verifiedReports() {
    return (this.deliverables.content ?? []).filter(
      (deliverable) => deliverable.generation_method === 'EXPERT_REVIEWED',
    );
  }

  get automatedReports() {
    return (this.deliverables.content ?? []).filter(
      (deliverable) => deliverable.generation_method === 'AUTOMATED',
    );
  }
}
